import DeviceCard from './DeviceCard/DeviceCard';
import DeviceDetails from './DeviceDetails';
import SourceCard from './SourceCard/SourceCard';

export { DeviceCard, SourceCard };
export default DeviceDetails;
